import * as React from 'react'
import { uniqueId } from 'lodash'

import Spinner from './Spinner'

export interface Props {
  loading: boolean
  errors: { [index: string]: Array<string> }
  onSubmit: (usernameOrEmail: string, password: string) => void
}

export interface State {
  readonly usernameOrEmail: string
  readonly password: string
}

export default class LoginForm extends React.Component<Props, State> {
  private readonly usernameOrEmailID = uniqueId('login-form-username-or-email')
  private readonly passwordID = uniqueId('login-form-password')

  constructor (props: Props, context?: any) {
    super(props, context)
    this.state = {
      usernameOrEmail: '',
      password: ''
    }
  }

  render () {
    if (this.props.loading) {
      return <Spinner stopped={false} />
    }
    const inputClass = 'p1 h3 mx-auto block'
    const inputWidth: React.CSSProperties = {
      width: '18rem'
    }
    const enableSignUp = this.validateForm()
    const fieldError = (key: 'username' | 'email' | 'password') => {
      const errors = this.props.errors[key]
      return errors ? (
        <div style={inputWidth} className='mx-auto mt1 red'>
          {errors.join(', ')}
        </div>
      ) : null
    }
    return (
      <form onSubmit={this._onSubmit}>
        <div className='clearfix '>
          <label htmlFor={this.usernameOrEmailID} className='hide'>
            Username
          </label>
          <input
            id={this.usernameOrEmailID}
            type='text'
            value={this.state.usernameOrEmail}
            className={inputClass}
            style={inputWidth}
            placeholder='Username or email'
            onChange={this._onFieldChanged}
            required
          />
          {fieldError('username')}
        </div>
        <div className='clearfix my3'>
          <label htmlFor={this.passwordID} className='hide'>
            Password
          </label>
          <input
            id={this.passwordID}
            type='password'
            value={this.state.password}
            className={inputClass}
            style={inputWidth}
            placeholder='Password'
            onChange={this._onFieldChanged}
            required
          />
          {fieldError('password')}
        </div>
        <div className='clearfix center mt2'>
          <button
            className='btn btn-primary'
            style={{ width: '18rem' }}
            disabled={!enableSignUp}>
            Login
          </button>
        </div>
      </form>
    )
  }

  private validateForm (): boolean {
    if (!this.state.usernameOrEmail.length) {
      return false
    }
    if (!this.state.password.length) {
      return false
    }
    return true
  }

  private _onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    this.props.onSubmit(this.state.usernameOrEmail, this.state.password)
    event.preventDefault()
  }

  private fieldKeyByID (id: string) {
    switch (id) {
      case this.usernameOrEmailID:
        return 'usernameOrEmail'
      case this.passwordID:
        return 'password'
    }
    return null
  }

  private _onFieldChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = this.fieldKeyByID(event.target.id)
    if (!key) {
      return
    }
    const value = event.target.value
    this.setState(state => ({
      ...state,
      [key]: value
    }))
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoginForm.tsx